import React, { useState } from 'react';

import FoundationTestKeys from '../../FoundationTestKeys';

import SpinnerOverlay from './SpinnerOverlay';

const spinnerDimensions = { width: 156, height: 156 };

const onAsyncActionPressed = async (asyncAction, onSuccess, onFailed, setIsLoading) => {
  try {
    setIsLoading(true);
    await asyncAction();
    onSuccess();
  } catch (error) {
    onFailed(error);
  } finally {
    setIsLoading(false);
  }
};

const withAsyncAction = WrappedComponent => {
  return props => {
    const [isLoading, setIsLoading] = useState(false);

    return (
      <>
        <SpinnerOverlay
          isVisible={isLoading}
          autoPlay={isLoading}
          lottieStyle={spinnerDimensions}
          loop
          testID={FoundationTestKeys.asyncSpinnerOverlay}
        />
        <WrappedComponent
          onAsyncActionPressed={(asyncAction, onSuccess, onFailed) => {
            return onAsyncActionPressed(asyncAction, onSuccess, onFailed, setIsLoading);
          }}
          {...props}
        />
      </>
    );
  };
};
export default withAsyncAction;
export { onAsyncActionPressed };
